import { Component, Input, EventEmitter, Output, ElementRef, DoCheck } from '@angular/core';
import { IKontaktDetailViewModel } from '../../models/kontakt-detail.model';
import { formatDate } from 'devextreme/localization';

@Component({
    selector: 'cz-kontakt-detail',
    templateUrl: 'kontakt-detail.component.html',
    styleUrls: ['kontakt-detail.component.css'],
    standalone: false
})
export class KontaktDetailComponent implements  DoCheck {

  ondrag: boolean;

  private localKontakt: IKontaktDetailViewModel;

  @Input()
  set kontakt(value: IKontaktDetailViewModel) {
    this.localKontakt = value;
  }
  get kontakt(): IKontaktDetailViewModel {
    return this.localKontakt;
  }

  get changeDate(): string {
    if (this.kontakt !== undefined && this.kontakt !== null && this.kontakt.aenderungsDatum !== undefined && this.kontakt.aenderungsDatum !== null) {
      return formatDate(new Date(this.kontakt.aenderungsDatum), 'shortDateShortTime');
    }
    else {
      return '';
    }
  }

  @Output() onKontaktRemove: EventEmitter<IKontaktDetailViewModel> = new EventEmitter<IKontaktDetailViewModel>();
  @Output() onKontaktEdit: EventEmitter<IKontaktDetailViewModel> = new EventEmitter<IKontaktDetailViewModel>();
  @Output() onEmailSend: EventEmitter<any> = new EventEmitter<any>();

  constructor(private el: ElementRef) {
  }

  ngDoCheck(): void {
    if (this.el.nativeElement.classList.contains('dnd-sortable-drag')) {
      if (!this.ondrag) {
        this.ondrag = true;
      }
    }
    else {
      if (this.ondrag) {
        this.ondrag = false;
      }
    }
  }

  onEmailSendFinished() {
    this.onEmailSend.emit(null);
  }

  onClickEditKontakt() {
    this.onKontaktEdit.emit(this.kontakt);
  }

  onClickRemoveKontakt() {
    if (confirm('Wirklich löschen?')) {
      this.onKontaktRemove.emit(this.kontakt);
    }
  }
}
